import React from 'react'
import { Col, ModalBody, Row,Button} from 'reactstrap';
import 'animate.css';
import { Dialog } from 'primereact/dialog';



export const ModalPreviewInvoicePatient = (props) => {
    
    const { loadingPreviewInvoicesP, showPreviewInvoicesPatient, handlePreviewPatientGlobal,handleCancelPatient,saveInvoicesPatient,loadingGlobalPatient } = props;

    return (
        <Dialog 
            visible={showPreviewInvoicesPatient}
			modal
			onHide={handleCancelPatient}
			style={{ width: '80vw', maxWidth: '900px', borderRadius: '16px' }}
			headerStyle={{
				background: 'linear-gradient( #bd2130)',
				color: 'white',
				fontWeight: 'bold',
				borderRadius: '12px 12px 0 0'
			}}
			pt={{
				header: { style: { backgroundColor: '#bd2130', color: 'white' } },
				headerIcon: { style: { color: 'white' } },
			}}
            header={loadingPreviewInvoicesP ? null : "Factura Global"} 
                        className={`pt-0 custom-dialog-bussine ${loadingPreviewInvoicesP ? 'no-header' : ''} ${loadingPreviewInvoicesP ? 'no-footer' : ''}`}  // Condicional para footer
                        footer={
                        !loadingPreviewInvoicesP && (
                            <div>
                                <Button 
                                    disabled={loadingGlobalPatient ? true : false} 
                                    outline 
                                    color="primary" 
                                    onClick={() => saveInvoicesPatient()}
                                >
                                    Aceptar
                                </Button>
                            </div>
                        )
                    }
            >
            <ModalBody>
                {
                    loadingPreviewInvoicesP && (
                        <>
                            <Row>
                                <Col sm="12" md="12" lg="12" className='text-center'>
                                    <img alt='modal-preview' src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "20%" }} />
                                </Col>
                                <Col sm="12" md="12" lg="12" className='text-center mt-1'>
                                    <p>Cargando ...</p>
                                </Col>
                            </Row>
                        </>
                    )
                }
                {!loadingPreviewInvoicesP && <Col sm="12" style={{textAlign:"center"}} className='p-l-0  p-r-0' >
                <img alt='modal-preview' src={require("../../assets/images/price/warnig-invoices.svg")}style={{ width: "15%" }} /> <br />
                <label className='f-14 f-w-600 txt-danger pt-1' >Esta seguro que estos nims, se facturaran a nombre del paciente</label>
                </Col>}
            </ModalBody>  
        </Dialog>
            )
        }
